import { B as BxfDatePickerDateFormatEnum, a as BxfDatePickerSeparatorsEnum } from './p-0cccf823.js';

const classes$5 = {
    CALENDAR: 'bxf-pill__calendar',
};
const constants = {
    DEFAULT_DATE_FORMAT: 'YYYY-MMM-DD',
    CALENDAR_DATE_FORMAT: BxfDatePickerDateFormatEnum.DD_MM_YYYY.replace(/\s/g, BxfDatePickerSeparatorsEnum.DASH),
};

const classes$4 = {
    CONTAINER: 'bxf-pill__container',
};

const classes$3 = {
    ICON: 'bxf-pill__icon',
};
// eslint-disable-next-line @typescript-eslint/prefer-as-const
const nodeName$2 = 'BxfPillIcon';

const classes$2 = {
    INLINE_MENU: 'bxf-pill__inline-menu',
};

const classes$1 = {
    INPUT_CONTAINER: 'bxf-pill__input-container',
    INPUT: 'bxf-pill__input',
};
const labels$1 = {
    INPUT_LABEL: 'Edit Pill',
};
const nodeName$1 = 'BxfPillInput';
const nodeNameInputContainer = 'BxfPillInputContainer';

const classes = {
    SIDE_BUTTON: 'bxf-pill__side-button',
    SIDE_BUTTON_ICON: 'bxf-pill__side-button-icon',
};
// eslint-disable-next-line @typescript-eslint/prefer-as-const
const nodeName = 'BxfPillSideButton';
const labels = {
    DELETE: 'Delete',
    LOCKED: 'Locked',
};

class BxfPillConstants {
    static COMPONENT_NAME = 'bxf-pill';
    static STRING = {
        ...classes$4,
        ...classes$1,
        ...classes,
        ...classes$5,
        ...classes$3,
        ...classes$2,
        TARGET: 'bxf-pill__target',
        PILL_VALIDATION_ERROR: 'bxf-pill__validation-error',
        PILL_VALIDATION_WARNING: 'bxf-pill__validation-warning',
    };
    static EVENTS = {
        CLICK_CLEAR: 'clickClear',
        CHANGE: 'change',
    };
}

export { BxfPillConstants as B, constants as a, classes$3 as b, classes$5 as c, classes$2 as d, classes$1 as e, nodeName$1 as f, nodeNameInputContainer as g, nodeName as h, classes as i, labels as j, labels$1 as l, nodeName$2 as n };
